import addComma from '@/filters/addComma'

export const getTooltip = (value, index) => {
  if ([7, 5, 3].indexOf(index.seriesIndex) !== -1) {
    // 7 >> CPA 6 >> Spent 3 >> AVG. CPC
    return addComma(value, '$')
  } else if ([2].indexOf(index.seriesIndex) !== -1) {
    // 2 >> CTR
    return addComma(value, '%')
  } else {
    // Rest
    return addComma(value)
  }
}